<template>
  <res-dialog 
    :showDialog="showDialog"
    :maxWidth="maxWidth"
    :setWidth="setWidth"
    :title="'Delete Group?'"
    :titleClass="'resBlue darken-1 white--text'"
    :showTitleIcon="true"
    :titleIconSize="17"
    :iconColor="'white'"
    :saveButtonText="'YES, DELETE'"
    :saveDisabled="false"
    :cancelButtonText="'NO'"
    :cancelButtonWidth="'80'"
    :defaultButtonAction="confirmDelete"
    @save="confirmDelete"
    @cancel="cancel" >
    <v-card-text>
      <span class="font-weight-500">
         {{message}}
      </span>
    </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';

  export default {
    name: 'DeleteGroupDialog',
    components: {
      ResDialog
    },
    props: {
      showDialog: {
        type: Boolean
      },
      groupName: {
        type: String
      },
      maxWidth: {
        type: Number
      },
      setWidth: {
        type: Number
      },
    },
    methods: {
      confirmDelete() {
        this.$emit('confirmDelete');
      },
      cancel() {
        this.$emit('cancelDelete');
      },
      
    },
    computed: {
      message() {
        return `All associated GL accounts for the '${this.groupName}' budget group will be excluded and can be reassigned by editing the desired Budget Group. Do you want to proceed?`;
      } 
    }
  }
</script>

